import type { CrossDomainFinding, Finding } from '@/model/Agent.model';
import type { FC } from 'react';
import { blocksSubmission } from '@/components/Agents/SendValidator/utils/SendSeverity';
import styles from './SendResults.module.scss';

interface SendBlockingMarkProps {
  finding: Finding | CrossDomainFinding;
}

/**
 * Says a finding blocks a submission, beside its severity and apart from it: blocking is its own axis,
 * never read off a level. Shown only for a rejection a published grading assigns, so a derived error,
 * however serious, never claims the FDA would refuse the file. Renders nothing otherwise, which in M1
 * is always.
 */
const SendBlockingMark: FC<SendBlockingMarkProps> = ({ finding }) =>
  blocksSubmission(finding) ? (
    <span className={styles.blockingMark} data-test-element="blocks-submission">
      Blocks submission
    </span>
  ) : null;

export default SendBlockingMark;
